import { log } from '@hotjar/insights-common/lib/log';
import { getParameter } from '@hotjar/insights-common/lib/url';

// Disabling eslint here since this is a copy paste from unbounce and we don't want to mess with it otherwise
// it's less easy to update this tracking snippet in the future.
/* eslint-disable */
const loadUnbounceScript = () => {
  var ub_script = document.createElement('script');

  ub_script.type = 'text/javascript';

  ub_script.async = !0;

  ub_script.src =
    ('https:' == document.location.protocol ? 'https://' : 'http://') +
    'd3pkntwtp2ukl5.cloudfront.net/uba.js';

  var s = document.getElementsByTagName('script')[0];

  s?.parentNode?.insertBefore(ub_script, s);
};
/* eslint-enable */

export const trackSignup = (): void => {
  if (getParameter(window.location.href, 'category') === 'unbounce') {
    log.debug('Unbounce: Tracking conversion');

    // eslint-disable-next-line no-underscore-dangle
    window._ubaq = window._ubaq || [];
    // eslint-disable-next-line no-underscore-dangle
    window._ubaq.push(['trackGoal', 'convert']);

    loadUnbounceScript();
  }
};
